import React, { useState, useEffect,useCallback } from "react";
import { Paper } from "@mui/material";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import DataTable from "../../../Requirement/components/common/ReusableTable";
import { useLoading } from "../../../../context/LoadingContext";
import { Auth } from "aws-amplify";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import OfferDetails from "./component/OfferDetails";
import {
  postQuery,
  postQueryBackendopsFun,
} from "../../../Requirement/services/RequirementServices";
import { useNavigate, useLocation } from "react-router-dom";
import { getParameterFromManager } from "../../../../services/Utils";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import dayjs from "dayjs";
import TrustScoreModal from "../../../../components/common/TrustScoreModal";

const GPBuyerUnapproved = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [gpOffers, setGPOffers] = useState([]);
  const [activeUser, setActiveUser] = useState("");
  const [products, setProducts] = useState([]);
  const [states, setStates] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [matchingOffersRequirement, setMatchingOffersRequirement] =
    useState(null);
  const [searchValues, setSearchValues] = useState({
    product: "",
    grade: "",
    state: "",
  });
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const handleModalClose = () => {
    if (modal.nextAction) {
      modal.nextAction();
    }
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
  };

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        style={{ width: "140px" }}
      >
        {label}
      </button>
    );
  };

  // Define currentPage before useEffect
  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const body = {
        target: "listProducts",
        rowStart: 0,
        pageSize: 1000,
      };

      const result = await postQuery(body);
      console.log(result);
      if (result) {
        setProducts(result.items);
      } else {
        console.error("Error fetching products");
      }
    } catch (error) {
      console.error("Error fetching products: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const body = {
        target: "listDynamicDropDownOptions",
        option: "gpofferitemstates",
        rowStart: 0,
        pageSize: 1000,
      };

      const result = await postQuery(body);
      console.log(result);
      if (result) {
        setStates(result.items.map((option) => option.result));
      } else {
        console.error("Error fetching states: ", result);
      }
    } catch (error) {
      console.error("Error fetching states: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGPOffers = async (searchValue, newRowStart = rowStart) => {
    setLoading(true);
    try {
      const filterTerms = {
        product: searchValues.product,
        grade: searchValues.grade,
        state: searchValues.state,
        IsApproved: 0,
        AdminStatus: 1,
      };

      const body = {
        target: "listGPOfferDetails",

        filterTerms,
        userOrder: "CreatedAt DESC",
        //userOrder: "GPOfferID ASC",
        rowStart: newRowStart,
        pageSize: pageSize,
        userType: "GlobalPartner",
      };

      const result = await postQuery(body);
      if (result) {
        setGPOffers(result.items);
        setTotalItems(result.total);
        // Auto-select the first offer if available
        console.log(result.items);
        if (result.items.length > 0) {
          const firstOffer = result.items[0];
          console.log(firstOffer);
          setSelectedOffer(firstOffer);
          setMatchingOffersRequirement(firstOffer); // Keep states in sync
        } else {
          setSelectedOffer(null);
          setMatchingOffersRequirement(null); // Clear states if no offers
        }
      } else {
        console.error("Error fetching gpOffers: ", result);
        setSelectedOffer(null);
        setMatchingOffersRequirement(null); // Clear states on error
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setSelectedOffer(null);
      setMatchingOffersRequirement(null); // Clear states on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchStates();
    fetchGPOffers();
  }, [currentPage, searchValues]);

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchGPOffers(searchValues, newRowStart);
  };

  const handleRowClick = (offer) => {
    setSelectedOffer(offer);
    setMatchingOffersRequirement(offer); // Keep states in sync
    console.log(offer);
  };

  const handleSearch = () => {
    setRowStart(0);
    setSelectedOffer(null); // Reset selectedOffer on new search
    fetchGPOffers(searchValues, 0);
  };

  const handleReset = () => {
    setSearchValues({
      product: "",
      grade: "",
      state: "",
    });
    setRowStart(0);
    setSelectedOffer(null); // Reset selectedOffer on reset
  };

  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No" },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    { id: "Quantity", numeric: false, label: "Quantity" },
    /* { id: "Price", numeric: false, label: "Price" }, */
    {
      id: "FOBSalePrice",
      numeric: true,
      label: "FOB Sale Price (USD)",
      renderCell: (row) => row.FOBSalePrice,
    },
    { id: "OriginCountry", numeric: false, label: "Orgin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination Country" },
    { id: "INCO", numeric: false, label: "Inco Term" },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) =>
        row.Expires ? dayjs(row.Expires).format("DD-MM-YYYY") : "",
    },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Type",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            row.GPOOfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    // { id: "OfferType", numeric: false, label: "OFFER TYPE" },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  const fields = [
    {
      name: "product",
      label: "Product",
      type: "dropdown",
      options: [...new Set(products.map((product) => product.ProductName))],
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, product: value })),
      value: searchValues.product,
    },
    {
      name: "grade",
      label: "Grade",
      type: "dropdown",
      options: [
        ...new Set(
          products
            .filter((product) => product.ProductName === searchValues.product)
            .map((product) => product.Grade)
        ),
      ],
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, grade: value })),
      value: searchValues.grade,
    },
    {
      name: "state",
      label: "State",
      type: "dropdown",
      options: states,
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, state: value })),
      value: searchValues.state,
    },
  ];
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_BUYERS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/global-partner");
      }
    };
    checkUser();
  }, [navigate]);
  const handleApprove = async (selectedGPOffer) => {
    setLoading(true);
    try {
      const body = {
        target: "gpApproveOffer",
        BuyerItemInput: {
          GPOfferID: selectedGPOffer.GPOfferID,
          GPEmailID: activeUser,
          Margin: selectedGPOffer.Margin,
          ProductID: selectedGPOffer.ProductID,
        },
      };
      const result = await postQueryBackendopsFun(body);
      if (result) {
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: "Approved successfully.",
          autoClose: false,
          nextAction: () => {
            setRowStart(0);
            fetchGPOffers(searchValues, 0);
            //navigate("/global-partner-buyer/offers");
          },
        });
      }
    } catch (e) {
      console.log("Error in handleApprove");
    } finally {
      setLoading(false);
    }
    // Approve the offer

    //console.log(body)
    //const result = await postQuery(body);
  };
  //const selectedRows = selectedGPOffer? [selectedGPOffer.GPOfferID || selectedGPOffer.id]: [];
  const selectedRows = selectedOffer ? [selectedOffer.GPOfferID] : [];
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Unapproved Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter
            fields={fields}
            onSearch={handleSearch}
            onReset={handleReset}
          />
        </div>
      </div>
      <div className="table-content">
        <DataTable
          columns={columns}
          data={gpOffers}
          onRowClick={handleRowClick}
          total={totalItems}
          title="Requirement Information"
          rowsPerPage={pageSize}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          selectedRows={selectedRows}
        />
      </div>
      {selectedOffer ? (
        <div className="card offer-content1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            <div className="tt0">
              {selectedOffer.IsApproved === 0 ? (
               
                <div className="button-group">
                <button className="submit-btn" onClick={trustModel} >Verification Status</button>
                <button
                  className="submit-btn"
                  onClick={() => handleApprove(selectedOffer)}
                >
                  Approve
                </button></div>
              ) : null}
            </div>
          </div>
          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            btnRaiseQuery={true}
            INRToUsd={INRToUsd}
          />
        </div>
      ) : (
        <div>No offer selected</div>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
    </Paper>
  );
};

export default GPBuyerUnapproved;
